import {Select} from 'grommet'
import { useState, useMemo, useCallback } from 'react'
import { useIntl } from 'react-intl'
import type {Country} from './types'
import { buildCountryList } from './utils'
export type {Country}

type Props = {
  name: string
  multiple?: boolean
  required?: boolean
}

// TODO: Fix bug with search, then re-enable

function CountryDropdown ({name, multiple = false, required = false}: Props) {
  const intl = useIntl()
  const [filter] = useState<string>('')
  // const [filter, setFilter] = useState<string>('')
  const [selectedCountries, setSelectedCountries] = useState<Country[]>([])

  const countryList: Country[] = useMemo(() => {
    return buildCountryList(intl.locale, filter)
  }, [intl.locale, filter])

  const onValueChange = useCallback(({ value }) => {
    const data = value
    setSelectedCountries(Array.isArray(data) ? data : [data])
  }, [])

  return (
    <Select
      multiple={multiple}
      closeOnChange={!multiple}
      required={required}
      messages={{multiple: selectedCountries?.map((country: Country) => country.name).join(', ')}}
      name={name}
      size="medium"
      placeholder={intl.formatMessage({ id: multiple ? 'form.fields.countryDropdown.multiplePlaceholder' : 'form.fields.countryDropdown.singlePlaceholder' })}
      emptySearchMessage={intl.formatMessage({ id: 'form.fields.countryDropdown.emptySearch' })}
      onChange={onValueChange}
      options={countryList}
      dropHeight="medium"
      // onSearch={setFilter}
      labelKey="name"
      valueKey="numericCode"
    />
  )
}

export default CountryDropdown
